import React, { useEffect } from 'react';
import { Segment, Header, Icon, Link } from 'nallian-shared-ui/lib/components';
import styled from 'styled-components';
import { Translation } from 'react-i18next';
import BasicLayout from '../../app/components/BasicLayout';

const SECONDS = 10;

const StyledSegment = styled(Segment)`
  max-width: 50rem;
  margin: 0 0.5rem;
  min-height: 25rem;
  &.ui.segment {
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    > div {
      transform: scale(1.2);
      transform-origin: center left;
      max-width: calc(100% / 1.2);
      padding-right: 1rem;
    }
    .icon {
      transform: scale(1.5);
    }
    .ui.header.huge {
      transform: scale(1.5);
      transform-origin: center left;
    }
    a {
      display: inline-block;
      margin: 0 0.5rem;

      :before {
        margin: 0 0.25rem;
        display: inline-block;
        border: transparent solid;
        color: ${props => props.theme.linkColor};

        height: 0.5rem;
        width: 0.5rem;
        content: '';
        border-left-color: ${props => props.theme.linkColor};
        border-width: 0.4rem 0.5rem;
        position: relative;
        top: 0.1rem;
        transform: translateX(0);
        transition: transform 0.5s;
      }
      :hover:before {
        animation: pulse 1s infinite;
        border-left-color: ${props => props.theme.linkColorHover};
      }
    }
  }

  @keyframes pulse {
    0% {
      transform: translateX(0);
    }
    50% {
      transform: translateX(0.25rem);
    }
    100% {
      transform: translateX(0);
    }
  }
`;

const NotFoundPage = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = `${window.location.origin}/overview`;
    }, SECONDS * 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <BasicLayout>
      <Translation>
        {t => (
          <StyledSegment>
            <Icon name="search" size="huge" margin="1rem 3rem 2rem -3rem" />
            <div>
              <Header size="huge" content={t('sorry!')} margin="0" />
              <Header size="medium" content={t('pageRequestedNotFound')} margin="1rem 0" />
              <Link to="/">{t('toTheCommunityPortal')}</Link>
            </div>
          </StyledSegment>
        )}
      </Translation>
    </BasicLayout>
  );
};

export default NotFoundPage;
